import React from 'react';
import { TabsStyled } from './tabs.styled';

interface TabsProps {
  value?: string;
  placement?: string;
  onClick?: (event: React.MouseEvent<HTMLElement>, value: string) => void;
  onClose?: () => void;
  children?: React.ReactNode | React.ReactNode[];
}

const Tabs = ({ value, onClick, onClose, children, placement }: TabsProps) => {
  return (
    <TabsStyled>
      {React.Children.map(children, (child: React.ReactElement, index) => {
        if (!child) return null;
        const childValue =
          child.props.value === undefined ? String(index) : child.props.value;

        return React.cloneElement(child, {
          active: value === childValue,
          onClick,
          onClose,
          placement,
          ...child.props,
        });
      })}
    </TabsStyled>
  );
};

Tabs.defaultProps = {
  placement: 'center',
  onClick: () => {},
};

export default Tabs;
